import debounce from 'debounce';

// lang switcher
document.addEventListener('DOMContentLoaded', function () {
  class StickyMenu extends HTMLElement {
    constructor() {
      super();
      // elements
      this.links = this.querySelectorAll('a');
      this.targets = this.links ? Array.from(this.links).map(link => document.querySelector(link.hash)) : [];
      this.header = document.querySelectorAll('s-header__main')[0];
    }
    connectedCallback() {
      // state
      this.positionY;
      this.heightMenu;
      // bindings
      this.bndHandleScroll = this.handleScroll.bind(this);
      this.bndScrollTo = this.scrollTo.bind(this);
      this.bndHandleResize = debounce(this.handleResize.bind(this), 250);
      // events
      this.onLoad();
      window.addEventListener('scroll', this.bndHandleScroll);
      this.addEventListener('click', this.bndScrollTo);
      window.addEventListener('resize', this.bndHandleResize);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.bndHandleScroll);
      this.removeEventListener('click', this.bndScrollTo);
      window.removeEventListener('resize', this.bndHandleResize);
    }
    onLoad() {
      this.checkCoordinates();
    }
    checkCoordinates() {
      this.positionY = this.offsetTop;
      this.heightMenu = this.header ? this.header.offsetHeight : 88;
    }
    handleResize() {
      this.checkCoordinates();
    }
    handleScroll() {
      // sticky the menu
      if (window.scrollY >= this.positionY - this.heightMenu) {
        this.classList.add('is-sticky');
      } else {
        this.classList.remove('is-sticky');
      }

      // active link      
      this.targets.forEach((target, index) => {
        if (target && this.links[index] && window.scrollY >= target.offsetTop - 200 && window.scrollY < target.offsetTop + target.offsetHeight - 200) {
          this.links[index].setAttribute('aria-current', 'true');
        } else {
          this.links[index].removeAttribute('aria-current');
        }
      });
    }
    scrollTo(event) {
      const trigger = event.target.closest('a');
      if (!trigger) return;
      event.preventDefault();
      const target = document.querySelector(trigger.getAttribute('href'));
      if (!target) return;
      window.scrollTo({
        top: target.offsetTop - 190,
        behavior: 'smooth'
      });
    }
  }
  customElements.define('sticky-menu', StickyMenu);
});